import { defineStore } from "pinia"
import { RouteLocationNormalized } from "vue-router"

import { MenuItem } from "~/types/MenuItem"

export const useMainMenuStore = defineStore("mainMenuStore", {
  state: () => ({
    selectedItemValues: ["dashboard"],
    items: [
      {
        value: "dashboard",
        title: "Sākums",
        url: "/",
        icon: "fa-house",
        categories: [],
        alwaysVisible: true,
        public: true,
      },
      {
        value: "smart-files",
        title: "Viedgrāmatas",
        icon: "fa-book-open",
        alwaysVisible: true,
        public: false,
        // plans: ["plus", "pro"],
        categories: [
          {
            value: "overview",
            title: "Pārskats",
            url: "/viedgramata",
            icon: "fa-th-large",
            alwaysVisible: true,
          },
          {
            value: "subjects",
            title: "Mācību priekšmeti",
            url: "/viedtemas",
            icon: "fa-pencil",
            alwaysVisible: true,
          },
          {
            value: "results",
            title: "Rezultātu atskaite",
            url: "/atskaite",
            icon: "fa-pie-chart",
            alwaysVisible: false,
            oldUrl: "rezultatu-atskaite",
            teacherWithLessons: true,
          },
          {
            value: "progressmeter",
            title: "Progresometrs",
            url: "/progress",
            icon: "fa-line-chart",
            alwaysVisible: false,
            progressometer: true,
            // plans: ["plus"],
            oldUrl: "progresometrs",
          },
        ],
      },
      {
        value: "e-books",
        title: "E-grāmatas",
        url: "/e-gramatas",
        icon: "fa-book-atlas",
        categories: [],
        alwaysVisible: true,
        public: true,
      },
      {
        value: "worksheet",
        title: "Darba lapas",
        url: "/darba-lapas",
        icon: "fa-file-text",
        categories: [],
        alwaysVisible: true,
        // plans: ["plus", "pro"],
      },
      {
        value: "video",
        title: "Video",
        url: "/video",
        icon: "fa-video-camera",
        categories: [],
        alwaysVisible: true,
        // plans: ["plus", "pro"],
      },
      {
        value: "methodical-supplies",
        title: "Metodiskie līdzekļi",
        url: "/metodiskie-lidzekli",
        icon: "fa-file-user",
        categories: [],
        alwaysVisible: false,
        // plans: ["pro"],
      },
      {
        value: "test-works",
        title: "Pārbaudes darbi",
        info: "Tikai skolotājiem",
        url: "/parbaudes-darbi",
        icon: "fa-pen-nib",
        categories: [],
        alwaysVisible: false,
        // plans: ["pro"],
      },
      {
        value: "active-inspire",
        title: "ActivInspire",
        url: "/interaktivie-materiali",
        icon: "fa-presentation-screen",
        categories: [],
        alwaysVisible: false,
        activeInspire: true,
      },
      {
        value: "e-courses",
        title: "E-kursi pedagogiem",
        url: "/e-courses",
        icon: "fa-puzzle-piece",
        categories: [],
        public: false,
        alwaysVisible: false,
        oldUrl: "e-kursi",
        coursesAllowed: true,
      },
      {
        value: "e-courses",
        title: "E-kursi pedagogiem",
        url: "/e-courses",
        icon: "fa-puzzle-piece",
        categories: [],
        public: false,
        alwaysVisible: false,
        oldUrl: "e-kursi",
        coursesUserActiveGroup: true,
      },
      {
        value: "my-products",
        title: "Bibliotēka",
        url: "/my-products",
        icon: "fa-books",
        categories: [],
        alwaysVisible: false,
        public: false,
        oldUrl: "my-products",
        hasActivatedProducts: true,
      },
      {
        value: "playlists",
        title: "Manas izlases",
        url: "/playlists",
        icon: "fa-bookmark",
        categories: [],
        alwaysVisible: false,
        public: true,
        oldUrl: "playlist/:slug",
      },
      {
        value: "journals",
        title: "Mani žurnāli",
        url: "/mani-zurnali",
        icon: "fa-book",
        categories: [],
        public: false,
        alwaysVisible: false,
        teacherWithLessons: true,
        studentWithLessons: true,
      },
    ] as MenuItem[],
  }),

  actions: {
    // TODO: Implement use of route names insdead of manually going through urls
    selectActiveItemValue(route: RouteLocationNormalized) {
      const values = [] as string[]
      const firstURLLocation = "/" + route.path.split("/")[1]

      this.items.forEach((item) => {
        if (item.url === firstURLLocation) {
          values.push(item.value)
        }
        item.categories.forEach((subItem) => {
          if (item.url === firstURLLocation) {
            values.push(item.value)
            values.push(subItem.value)
          }
        })
      })

      if (values.length === 0) {
        this.items.forEach((item) => {
          if (item.url && item.url !== "/" && item.url.match(firstURLLocation)) {
            values.push(item.value)
          }
          item.categories.forEach((subItem) => {
            if (subItem.url && subItem.url !== "/" && subItem.url.match(firstURLLocation)) {
              values.push(item.value)
              values.push(subItem.value)
            }
          })
        })
      }
      this.selectedItemValues = values
    },

    isSelected(value: string) {
      return this.selectedItemValues.includes(value)
    },
  },
})
